module.exports = __webpack_public_path__ + "static/media/00.24e97e0e.webp";